export function setBaseTag(tenant) {
  if (tenant) {
    document.write("<base href='/" + tenant + "/start' />");
  }
}

export function getTenantNameFromHost() {
  return window.location.pathname
    .substring(0, window.location.pathname.lastIndexOf("/") + 1)
    .replace(/\//g, "");
}
